import Vue from 'vue'
import Vuex from 'vuex'
import MobileDetect from 'mobile-detect'
import _ from 'lodash'

Vue.use(Vuex)

const state = {
  splitArea: {},
  inResolution: {},
  outResolution: {},
  outRatio: [],
  inRatio: [],
  windowFocus: '4',
  defaultSplit: [
    '4x1',
    '1x4',
    '2x2',
    '1x1',
    '4*1@90',
    '4*1@270',
    '3*1@90',
    '3*1@270'
  ]
}

const mutations = {
  changeOutPos (state, payload) {
  },
  UPDATE (state, {type, splitArea, resolution, windowFocus, setting}) {
    if (type === 'split') {
      let newSplit = splitArea
      state.splitArea = newSplit
    } else if (type === 'winFocus') {
      state.windowFocus = windowFocus
    } else if (type === 'inResolution' || type === 'outResolution') {
      let newResolution = resolution
      state[type] = newResolution
    } else if (type === 'inRatio') {
      let newRatio = []
      switch (state.inResolution['1']) {
        case '800x600':
        case '800x600@60':
        default:
          newRatio = [4, 3, 200]  // [width, height, baseWidth]
          break
        case '1920x1200':
        case '1920x1200@60':
          newRatio = [16, 10, 120]
          break
        case '1920x1080':
        case '1920x1080@60':
        case '576p':
          newRatio = [16, 9, 120]
          break
        case '640x480':
        case '640x480@60':
        case '480p':
          newRatio = [4, 3, 160]
          break
      }
      let md = new MobileDetect(window.navigator.userAgent)
      let ww = window.innerWidth
      if (md.mobile() !== null && ww < 768) {
        if (ww === 568) { // i5 landscape
          newRatio.push(Math.round(360 / newRatio[0]))
        } else if (ww === 684) { // Nexus 5X landscape
          newRatio.push(Math.round(500 / newRatio[0]))
        } else if (ww > 568 && ww <= 667) { // i6 landscape
          newRatio.push(Math.round(460 / newRatio[0]))
        } else if (ww > 667 && ww <= 736) { // i6+ landscape
          newRatio.push(Math.round(520 / newRatio[0]))
        } else { // set 300 to others
          newRatio.push(Math.round(300 / newRatio[0]))
        }
      } else if (ww >= 768 && ww < 992) {
        newRatio.push(Math.round(480 / newRatio[0])) // ipad UP
      } else if (ww >= 992 && ww < 1200) {
        newRatio.push(Math.round(600 / newRatio[0])) // md
      } else if (ww >= 1200) {
        newRatio.push(Math.round(800 / newRatio[0])) // lg
      }
      state[type] = newRatio
    } else if (type === 'outRatio') {
    } else if (type === 'split') {
      state.splitArea = _.cloneDeep(setting)
    }
  }
}
const actions = {
  updateWinFocus ({ commit }, key) {
    commit('UPDATE', {
      type: 'winFocus',
      windowFocus: key
    })
  },
  updateSplitArea ({ commit }, setting) {
    console.log('updateSplitArea')
    // commit('UPDATE', {
    //   type: 'split',
    //   setting: setting
    // })
  }
}
const getters = {
  getInScreenWidth: state => {
    return state.inRatio[0] * state.inRatio[3]
  },
  getInScreenHeight: state => {
    return state.inRatio[1] * state.inRatio[3]
  },
  getOutScreenWidth: state => {
    return state.outRatio[0] * state.outRatio[3]
  },
  getOutScreenHeight: state => {
    return state.outRatio[0] * state.outRatio[3]
  },
  getWindowFocus: state => {
    return state.windowFocus
  },
  getComputedSplit: state => {
    let newSplit = _.cloneDeep(state.splitArea)
    for (let key of newSplit) {
      for (let i in newSplit[key]) {
        newSplit[key][i] = newSplit[key][i] / state.inRatio[2] * state.inRatio[3]
      }
    }
    return newSplit
  }
}
export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/videoStore.js